import React from "react";
import PhoneInputComponent, { PhoneInputProps } from "react-phone-input-2";
import { twMerge } from 'tailwind-merge';

interface PropTypes extends PhoneInputProps {
  label?: string;
  error?: string;
  name: string;
  isInvalid: boolean;
  className?: string;
  labelClassName?: string;
  inputFieldClassName?: string;
  responsiveFont?: boolean;
}

const PhoneInput = ({ label, name, error, isInvalid, className, labelClassName, inputFieldClassName, responsiveFont = false, ...rest }: PropTypes) => {
  const labelClass = responsiveFont ? "text-[1rem] lg:text-xs" : "text-base";
  const inputClass = responsiveFont ? "!text-[1rem] lg:!text-xs" : "!text-base";
  const errorClass = responsiveFont ? "text-[1rem] lg:text-xs" : "";

  return (
    <div className="flex flex-col">
      {label && <label className={twMerge("label", labelClass, labelClassName)}>{label}</label>}
      <PhoneInputComponent
        inputProps={{ name }}
        inputClass={`!w-full ${inputClass} !border-none !h-full  rounded-lg`}
        containerClass="!flex !items-center border border-primary rounded-lg h-10 w-full"
        inputStyle={{
          border: "none",
          height: "100%",
          width: "100%",
          fontSize: inputFieldClassName ? inputFieldClassName : "1rem",        // ✅ increased from 0.75rem
          background: "transparent", // ✅ prevents background shrink
        }}
        buttonStyle={{
          background: "transparent",
          border: "none",
        }}
        country="us"
        {...rest}
      />
      {isInvalid && (
        <label className="label py-0.5">
          <span className={twMerge("label-text-alt text-red-600", errorClass)}>{error}</span>
        </label>
      )}
    </div>
  );
};

export default PhoneInput;